import blogPostCategoryLibrary from './prioritized-blog-post-tag-list'

/*
* Takes in all the blog posts categories. Checks if it has the highest prioritized tag in it, 
* otherwise continue with less prioritized. Returns the corespoding tagText for that category,
* given prioritizedBlogPostTagList. If none of the categories are in the prioritizedBlogPostTagList,
* give the blog post the category 'travel guide'.
*/
export const getTagTextFromCategories = (categories) => {
  if (typeof categories == 'object') {
    for (let category in blogPostCategoryLibrary.prioritizedBlogPostTagList) {
      if (categories.includes(blogPostCategoryLibrary.prioritizedBlogPostTagList[category].id)) {
        return blogPostCategoryLibrary.prioritizedBlogPostTagList[category].value
      }
    }
  }
  return blogPostCategoryLibrary.prioritizedBlogPostTagList[blogPostCategoryLibrary.prioritizedBlogPostTagList.length - 1].value
}

export const removePTags = (text) => {
  return text.replace(/<p>/g, '').replace(/<\/p>/g, '')
}

/*
* Slices the text to right amount of characthers.
* Depending on end of string, add appropriate number of dots and/or slice exessive blank spaces.
*/
export const getTextPreview = (text, maxLength) => {
  if (text.length > maxLength - 3) {
    const slicedText = text.substring(0, maxLength - 3)
    const indexOfLastSpace = slicedText.lastIndexOf(' ')
    return text.substring(0, indexOfLastSpace) + '...'
  }
  else if (text.length === 0) {
    return ''
  }
  else if(text[text.length] === ' ') {
    return text.substring(0, text.length -1) + '...'
  }
  else {
    const slicedText = text.substring(0, text.length)
    const indexOfLastSpace = slicedText.lastIndexOf(' ')
    return text.substring(0, indexOfLastSpace) + '...'
  }
}


module.exports = {getTagTextFromCategories, removePTags, getTextPreview}